import {
  Link,
  Navigate,
  NavLink,
  Outlet,
  useNavigate,
} from "react-router-dom";
import { useEffect } from "react";
import { isAuthenticated, getUserInfo, clearCookies } from "./../Auth";
import { useState } from "react";

import logo from "../assets/images/brand-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MainLayout = () => {
  const [userInfo, setUserInfo] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    //console.log(isAuthenticated());
    if (isAuthenticated()) {
      if (getUserInfo().userType === "Employee") {
        navigate("/home");
      }

      setUserInfo(getUserInfo());
    } else {
      navigate("/login");
    }
  }, [navigate]);

  const logout = () => {
    //Cookies.remove("access_token");
    //Cookies.remove("userInfo");
    clearCookies();
    navigate("/login");
  };

  return (
    <>
      {isAuthenticated() ? "" : <Navigate to={"/login"} />}

      <header className="nav-bar bg-light bd-navbar sticky-top">
        <nav className="container flex align-center justify-between">
          <div className="navbar-toggle">
            <button
              className="navbar-toggler p-2"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#bdSidebar"
              aria-controls="bdSidebar"
              aria-label="Toggle docs navigation"
            >
              <FontAwesomeIcon icon={"bars"}/>
              <span className="d-none fs-6 pe-1">Browse</span>
            </button>
          </div>

          <div className="brand-logo">
            <Link to={"/"}>
              <img src={logo} alt="Attitude Crafters Logo" className="brand-logo"></img>
            </Link>
          </div>

          <div className="nav-menu flex flex-1 align-center">
            <div className="flex">
              <NavLink className={"nav-link"} to="/">
                Dashboard
              </NavLink>
              <NavLink className={"nav-link"} to="/approval">
                Approval
              </NavLink>
              <NavLink className={"nav-link"} to="/users">
                Users
              </NavLink>
              <NavLink className={"nav-link"} to="/invoicing">
                Invoicing
              </NavLink>
              <NavLink className={"nav-link"} to="/reconciliation">
                Reconciliation
              </NavLink>
              <NavLink className={"nav-link"} to="/reports">
                Reports
              </NavLink>
            </div>
          </div>
          <div className="flex align-center">
            <div className="name mr-2">{userInfo.userName}</div>
            <button type="button" className="btn btn-light" onClick={logout}>
              Logout
            </button>
          </div>
        </nav>
      </header>

      <div className="container page-inner mt-3">
        <Outlet />
      </div>

      <footer className="footer">
        <div className="poweredby text-center">
          Powered by{" "}
          <a rel="noreferrer" href="http://technixindia.com" target={"_blank"}>
            Technix India Solutions (P) Limited
          </a>
        </div>
      </footer>
    </>
  );
};

export default MainLayout;
